import { render } from "./cpt-video-player-option.vue?vue&type=template&id=12fcfc67"
import script from "./cpt-video-player-option.vue?vue&type=script&lang=js"
export * from "./cpt-video-player-option.vue?vue&type=script&lang=js"

import "./cpt-video-player-option.vue?vue&type=style&index=0&id=12fcfc67&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__